/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:44:39 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-06 12:00:49
 */

import { Injectable } from "@angular/core";
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';

import { of } from 'rxjs/Observable/of';
import { Observable } from "rxjs/Observable";

import * as AuthActions from './auth.action';

import { AuthService } from "../../services/auth.service";
import { UserService } from "../../services/user.service";
import { LoadingService } from "../../services/loading.service";

@Injectable()
export class AuthEffects {
  constructor(
    private loadingService: LoadingService,
    private authService: AuthService,
    private userService: UserService,
    private actions$: Actions) {
  }

  @Effect()
  TryLogin$: Observable<Action>
    = this.actions$.ofType<AuthActions.TryLogin>(AuthActions.TRYLOGIN)
      .switchMap(action => {
        if (this.authService.userId) {
          this.loadingService.showLoading(true);
          return this.userService.getUser(this.authService.userId)
            .map(res => {
              this.loadingService.showLoading(false);
              return new AuthActions.TryLoginSuccess(res['payload']);
            })
            .catch(() => of(new AuthActions.TryLoginError()))
        } else {
          return of(new AuthActions.TryLoginError());
        }
      });


  @Effect()
  Login$: Observable<Action>
    = this.actions$.ofType<AuthActions.Login>(AuthActions.LOGIN)
      .switchMap(action => {
        this.loadingService.showLoading(true);
        return this.authService.login(action.phone, action.password, action.snsId, action.provider)
          .map(res => {
            const token = res['payload']['token'];
            const user = res['payload']['user'];
            this.authService.token = token;
            this.authService.userId = user._id;
            this.loadingService.showLoading(false);
            return new AuthActions.LoginSuccess(user, token);
          })
          .catch(() => of(new AuthActions.LoginError()));
      });

  @Effect({ dispatch: false })
  Logout$: Observable<Action>
    = this.actions$.ofType<AuthActions.Logout>(AuthActions.LOGOUT)
      .do(() => this.authService.clearAuthInfo());

}


// WEBPACK FOOTER //
// ./src/store/auth/auth.effect.ts